import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Headphones } from "lucide-react";

/** Welcome advantage of a new fan account (backend/routers/discovery.py): shown only while
 * it lasts, so the fan knows they may listen to one paid song in full each day. */
export default function DiscoveryBanner() {
  const { user } = useAuth();
  const [d, setD] = useState(null);
  useEffect(() => {
    if (user?.role !== "viewer") return;
    api.get("/discovery/me").then((r) => setD(r.data)).catch(() => {});
  }, [user]);
  if (!d?.eligible) return null;
  return (
    <div className="mb-5 rounded-2xl px-4 py-3 border border-[#00F2FE]/25 bg-[#00F2FE]/10 flex items-start gap-3" data-testid="discovery-banner">
      <Headphones className="w-5 h-5 text-[#00F2FE] shrink-0 mt-0.5" />
      <p className="text-sm text-zinc-200">
        <strong className="text-white">Bienvenue !</strong> Pendant encore {d.days_left} jour{d.days_left > 1 ? "s" : ""}, écoute les chansons
        <strong className="text-white"> en entier, gratuitement</strong>. Lance une chanson, puis touche « Écouter en entier ».
      </p>
    </div>
  );
}
